export const useAuth = () => {
  // 获取 Consent 状态
  const getConsent = () => {
    if (typeof window === 'undefined') return false
    return localStorage.getItem('cookieConsent') === 'true'
  }

  // 检查是否在本次会话中拒绝过 (Session Consent)
  const getSessionReject = () => {
    if (typeof window === 'undefined') return false
    return sessionStorage.getItem('cookieConsent') === 'false'
  }

  // 设置 Consent
  const setConsent = (accepted: boolean) => {
    if (typeof window === 'undefined') return
    if (accepted) {
      localStorage.setItem('cookieConsent', 'true')
      // 清除拒绝标记
      sessionStorage.removeItem('cookieConsent')
    } else {
      localStorage.removeItem('cookieConsent')
      sessionStorage.setItem('cookieConsent', 'false')
    }
  }

  // 获取 Token
  const getToken = () => {
    if (typeof window === 'undefined') return null
    return localStorage.getItem("Token") || 
           localStorage.getItem("token") || 
           localStorage.getItem("authToken") ||
           sessionStorage.getItem("Token") || 
           sessionStorage.getItem("token") || 
           sessionStorage.getItem("authToken")
  }

  // 获取存储方式
  const getStorage = () => {
    if (typeof window === 'undefined') return null
    const consent = getConsent()
    return consent ? localStorage : sessionStorage
  }

  // 设置登录信息
  const setLoginInfo = (result: any) => {
    if (typeof window === 'undefined') return
    const storage = getStorage()
    if (!storage) return
    
    try {
      storage.setItem("loginResult", JSON.stringify(result))
    } catch {}
    
    storage.setItem("hadLogin", "true")
    
    const expiresTimeStamp = (result.expiresIn ? (result.expiresIn * 1000) / 2 : 0) + Date.now()
    storage.setItem("expiresTimeStamp", String(expiresTimeStamp))
    
    if (result.accessToken) {
      storage.setItem("Token", result.accessToken)
    }
  }

  // 设置用户信息
  const setUserInfo = (userInfo: any) => {
    if (typeof window === 'undefined') return
    const storage = getStorage()
    if (!storage) return
    
    try {
      storage.setItem("userInfo", JSON.stringify(userInfo))
    } catch {}
  }

  // 获取用户信息
  const getUserInfo = () => {
    if (typeof window === 'undefined') return null
    const storage = getStorage()
    if (!storage) return null
    
    try {
      const userInfoStr = storage.getItem("userInfo")
      return userInfoStr ? JSON.parse(userInfoStr) : null
    } catch {
      return null
    }
  }

  // 检查是否登录
  const checkLogin = () => {
    if (typeof window === 'undefined') return false
    
    const hadLogin = (localStorage.getItem("hadLogin") || sessionStorage.getItem("hadLogin")) === "true"
    const token = getToken()
    const expStr = localStorage.getItem("expiresTimeStamp") || sessionStorage.getItem("expiresTimeStamp")
    const exp = expStr ? Number(expStr) : 0
    const notExpired = exp > Date.now()
    
    return !!token && hadLogin && notExpired
  }

  // 登出
  const logout = () => {
    if (typeof window === 'undefined') return
    localStorage.removeItem("Token")
    localStorage.removeItem("token")
    localStorage.removeItem("authToken")
    localStorage.removeItem("hadLogin")
    localStorage.removeItem("expiresTimeStamp")
    localStorage.removeItem("loginResult")
    localStorage.removeItem("userInfo")

    sessionStorage.removeItem("Token")
    sessionStorage.removeItem("token")
    sessionStorage.removeItem("authToken")
    sessionStorage.removeItem("hadLogin")
    sessionStorage.removeItem("expiresTimeStamp")
    sessionStorage.removeItem("loginResult")
    sessionStorage.removeItem("userInfo")
  }

  return {
    getConsent,
    getSessionReject,
    setConsent,
    getToken,
    setLoginInfo,
    setUserInfo,
    getUserInfo,
    checkLogin,
    logout
  }
}
